export const dictionary = {
	de: {
		// Standard
		home: 'Home',
		login: 'Anmelden',
		workers: 'Mitarbeiter',
		projects: 'Projekte',
		customers: 'Kunden',
		dailyProjectReports: 'Baustellenberichte',
		workerTimeReports: 'Tagesberichte',
		reportManagement: 'Berichtsverwaltung',

		// MIS -Management Information System
		mis: 'MIS',
		dashboard: 'Dashboard',
		kpi: 'Kennzahlen',
		map: 'Karte',

		// Times
		times: 'Zeitverwaltung',
		workerTimes: 'Mitarbeiter-Einsicht',
		workerTimesOverview: 'Mitarbeiter-Übersicht',
		periodTimes: 'Jahresübersicht',

		//contacts
		contacts: 'Kontakte',
		organizations: 'Organisationen',
		persons: 'Personen',

		// Administration
		administration: 'Administration',
		users: 'Benutzer',
		groups: 'Rollen',
		basicData: 'Basisdaten',
		databases: 'Datenbanken',

		reports: 'Berichte',
		singleTimeRecord: 'Einzelerfassung',

		projectTimeReportMobileManagement: 'Meine Baustellenberichte',
		projectTimeReportMobileWindow: 'Baustellenbericht Mobile',
		mobile: 'Mobile',
		homeMobile: 'Home Mobile',
	},
	en: {
		home: 'Home',
		login: 'Login',
		workers: 'Workers',
		projects: 'Projects',
		companies: 'Companies/Institutions',
		customers: 'Customers',
		reports: 'Reports',
		singleTimeRecord: 'Single Work Record',
		dailyTimeRecord: 'Daily Work Record',
		contactPersons: 'Contacts',
		workRecord: 'Work Record',
		administration: 'Administration',
		users: 'User',
		groups: 'Roles',
		basicData: 'Basisdaten',
		mobile: 'Mobile',
		homeMobile: 'Home Mobile',
	},
};
